const TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO = [
  {
    id: 1,
    name: 'Libre'
  },
  {
    id: 2,
    name: 'Bolsa de Licenciamiento'
  },
]

export {
  TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO
}
